export enum titleMotherFather {
  Madre = 'Madre',
  Padre = 'Padre',
}
